<template>
<div
        v-if="!isCloudDiskDoc"
        class="head_star_icon_container"
        @click="clickStar"
        @mouseenter="starMouseEnter"
        @mouseleave="starMouseLeave"
    >
        <moo-tooltip
            effect="light"
            :content="starTip"
            placement="bottom"
            popper-class="customPoperClass_star_entry"
            :visible-arrow="false"
            :value="showTip"
            v-if="showTip"
        >
            <svg-icon
                class="head_star_icon"
                :icon-class="starIconName"
            ></svg-icon>
        </moo-tooltip>
        <svg-icon
            v-else
            class="head_star_icon"
            :icon-class="starIconName"
            ></svg-icon>
    </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { starFile } from '@/api/h5/file';
import { debounce } from "@/utils/lodash";

export default {
  name: 'test_vue',
  props: {
    metadata: {
      type: Object,
      required: true
    },
    isCloudDiskDoc: {
      type: Boolean,
      default: false
    }
  },
  emits: [],
  components: {

  },
  data() {
    return {
      debounceStarFile: null,
      showTip: false
    };
  },
  computed: {
    starTip() {
      return this.metadata.star === true ? intl.$t("取消收藏#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_1") : intl.$t("收藏#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_1");
    },
    starIconName() {
      return this.metadata.star === true ? "file_star" : "file_unstar";
    }
  },
  methods: {
    starMouseEnter() {
      console.log('---------------starMouseEnter');
      this.showTip = true;
    },
    starMouseLeave() {
      console.log('-----------------starMouseLeave');
      this.showTip = false;
    },
    clickStar() {
      this.showTip = false;
      if (this.metadata.star === undefined || this.metadata.star === null) {
        this.$message.error(intl.$t("收藏失败#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_1"));
        return;
      }
      if (this.metadata.star === true) {
        this.debounceStarFile(this.metadata.fileId, false);
      } else {
        this.debounceStarFile(this.metadata.fileId, true);
      }
    },
    async requestStarFile(fileId, isStar) {
      try {
        const res = await starFile(isStar, fileId);
        const { code, data, message } = res || {};
        if (code == 200) {
          if (isStar) {
            this.$message.success(intl.$t("已添加到“收藏”#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_1"));
            this.metadata.star = true;
            window.parent.postMessage("starFile", "*");
          } else {
            this.$message.success(intl.$t("已从“收藏”中移除#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_1"));
            this.metadata.star = false;
            window.parent.postMessage("unstarFile", "*");
          }
        }
      } catch (err) {
        if (isStar) {
          this.$message.error(intl.$t("收藏失败#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_2"));
        } else {
          this.$message.error(intl.$t("取消收藏失败#!!!#src/pages/H5/Cloud/components/star/FileStar.vue_1"));
        }
      }
    }
  },
  mounted() {
    this.debounceStarFile = debounce(this.requestStarFile, 500);
  },
  unmounted() {
    this.debounceStarFile = null;
  }
};
</script>

<style lang="scss" scoped>
.head_star_icon_container {
  margin-left: -3px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f4f6f9;
    border-radius: 6px;
  }

  .head_star_icon {
    width: 14px;
    height: 14px;
  }
}
</style>

<style lang="scss">
.customPoperClass_star_entry {
  top: 35px !important;
  border-radius: 4px m !important;
  color: #767c85;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  height: 22px;
  line-height: 24px !important;
  margin-top: 5px !important;
  text-align: center !important;
}
</style>
